// Pop-outs (/popup/*) are never scaled, and the sign-in page, the client
// portal and every other signed-out page use Auto whoever is signed in
// (lib/displayZoom.js isAutoOnlyPath, James D3 2026-10-29).  The zoom reads
// the path whenever it evaluates — so App.js re-evaluates when an in-app
// navigation crosses into or out of either (signing in moves /login → the
// start page without a reload).  The first run is a no-op unless index.js
// started on the other side.
import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { isPopupPath, isAutoOnlyPath, refreshDisplayZoom } from '../lib/displayZoom'

export default function useDisplayZoomRouteSync () {
  const { pathname } = useLocation()
  const area = isPopupPath(pathname) ? 'popup' : isAutoOnlyPath(pathname) ? 'auto-only' : 'app'
  useEffect(() => {
    refreshDisplayZoom()
  }, [area])
}
